import { ReactNode } from "react";

interface TWButtonProps {
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  variant?: "primary" | "secondary" | "tab";
  size?: "sm" | "md" | "lg";
  isActive?: boolean;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
}

const TWButton = ({
  onClick,
  type = "button",
  variant = "primary",
  size = "md",
  isActive = false,
  icon,
  children,
  className = "",
  disabled = false,
}: TWButtonProps) => {
  // Base classes
  const baseClasses =
    "font-medium uppercase tracking-wider transition-colors flex items-center justify-center rounded-full";

  // Variant classes
  const variantClasses = {
    primary: "bg-black text-white hover:bg-gray-800 shadow-sm",
    secondary: "bg-gray-200 text-gray-700 hover:bg-gray-300",
    tab: isActive
      ? "bg-black text-white shadow-sm"
      : "text-gray-600 hover:text-gray-900",
  };

  // Size classes
  const sizeClasses = {
    sm: "px-3 py-1.5 text-xs",
    md: "px-4 py-2 text-sm",
    lg: "w-full sm:w-56 h-12 text-sm",
  };

  // Tab-specific classes
  const tabClasses = variant === "tab" ? "flex-1" : "";

  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : "";

  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${tabClasses} ${disabledClasses} ${className}`}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
};

export default TWButton;
